module Meevo.Plugins.NotificationSetting {
    "use strict";
    import CommunicationTypeEnum = Meevo.Model.CommunicationTypeEnum;
    import BulkClientNotificationUpdateEnum = Meevo.Model.BulkClientNotificationUpdateEnum;
    import BulkUpdateProcessingStatusEnum = Meevo.Model.BulkUpdateProcessingStatusEnum;
    import BulkNotificationUpdateSetting = Meevo.Model.BulkNotificationUpdateSetting;

    export class NotificationSettingBaseSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public emptyGuidId = "00000000-0000-0000-0000-000000000000";
        public allBusinessTypeId = "00000000-0000-0000-0000-000000000001";

        public showEllipsisContent = false;
        public selectedEllipsisType: any;

        public isBulkEmailOptInUpdated = false;
        public isBulkSMSOptInUpdated = false;
        public isBulkSendSMSOptInUpdated = false;
        public bulkNotificationUpdateSettingList: BulkNotificationUpdateSetting[];

        public showCollapseContent = false;
        public selectedCollapseType: any;

        constructor(
            protected isApplicationModeCO: boolean,
            protected isSingleLocation: boolean,
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
        }

        public activate(): void {
            super.activate();

            if (this.isSingleLocation ||
                (this.isApplicationModeCO &&
                    (!this.model.businessType_TId || this.model.businessType_TId == null || Guid.empty.equals(this.model.businessType_TId) || this.model.businessType_TId == this.allBusinessTypeId))) {
                this.loadBulkUpdateSetting();
            }
        }

        rollbackChanges(): void {
            super.rollbackChanges();

            // Rollback bulk update setting
            if (this.isSingleLocation ||
                (this.isApplicationModeCO &&
                    (!this.model.businessType_TId || this.model.businessType_TId == null || Guid.empty.equals(this.model.businessType_TId) || this.model.businessType_TId == this.allBusinessTypeId))) {

                var originalBulkUpdateSetting: any = this.originalEntity.bulkUpdateSetting;
                if (originalBulkUpdateSetting) {
                    this.model.bulkUpdateSetting = angular.copy(originalBulkUpdateSetting);
                }
                this.loadBulkUpdateSetting();
            }
        }

        public getDaysPriorLabel(communicationType: CommunicationTypeEnum): string {
            let label = 'LABEL_DAYS_BEFORE';

            switch (communicationType) {
                case CommunicationTypeEnum.FiveStarSurvey:
                    label = 'LABEL_DAYS_AFTER';
                    break;
                case CommunicationTypeEnum.AppointmentCheckIn:
                    label = 'LABEL_HOURS_BEFORE';
                    break;
            }

            return label;
        }

        loadBulkUpdateSetting(): void {

            this.showEllipsisContent = false;

            // Initialize/reset bulk update settings
            this.isBulkEmailOptInUpdated = false;
            this.isBulkSMSOptInUpdated = false;
            this.isBulkSendSMSOptInUpdated = false;

            this.bulkNotificationUpdateSettingList = [
                { communicationType: 0, bulkUpdateType: BulkClientNotificationUpdateEnum.RemoveOverrideIfItMatchDefault, isBulkEmailUpdated: false, isBulkSMSUpdated: false, isBulkSendDaysUpdated: false },
                { communicationType: 0, bulkUpdateType: BulkClientNotificationUpdateEnum.RemoveForAllClient, isBulkEmailUpdated: false, isBulkSMSUpdated: false, isBulkSendDaysUpdated: false },
                { communicationType: 0, bulkUpdateType: BulkClientNotificationUpdateEnum.AddOverrideForClientsWithoutOne, isBulkEmailUpdated: false, isBulkSMSUpdated: false, isBulkSendDaysUpdated: false }
            ];

            // Load bulk update setting
            if (this.model.bulkUpdateSetting &&
                this.model.bulkUpdateSetting.processStatusType &&
                this.model.bulkUpdateSetting.processStatusType == BulkUpdateProcessingStatusEnum.ToBeProcessed) {

                this.model.isBulkUpdateToBeProcessed = true;
                this.model.isBulkUpdateSettingEnabled = true;

                // Load bulk update setting
                if (this.model.bulkUpdateSetting.isBulkEmailOptInUpdated) {
                    this.isBulkEmailOptInUpdated = this.model.bulkUpdateSetting.isBulkEmailOptInUpdated;
                }
                else if (this.model.bulkUpdateSetting.isBulkSMSOptInUpdated) {
                    this.isBulkSMSOptInUpdated = this.model.bulkUpdateSetting.isBulkSMSOptInUpdated;
                    if (this.model.bulkUpdateSetting.isBulkSendSMSOptInUpdated)
                        this.isBulkSendSMSOptInUpdated = this.model.bulkUpdateSetting.isBulkSendSMSOptInUpdated;
                }
                else if (this.model.bulkUpdateSetting.isBulkEmailUpdated || this.model.bulkUpdateSetting.isBulkSMSUpdated || this.model.bulkUpdateSetting.isBulkSendDaysUpdated) {
                    var bulkUpdateOption: any = _.findWhere(this.bulkNotificationUpdateSettingList, { bulkUpdateType: this.model.bulkUpdateSetting.bulkUpdateType });
                    if (bulkUpdateOption) {

                        bulkUpdateOption.communicationType = this.model.bulkUpdateSetting.communicationType;
                        this.showEllipsisContent = true;
                        this.selectedEllipsisType = this.model.bulkUpdateSetting.communicationType;

                        if (this.model.bulkUpdateSetting.isBulkEmailUpdated) {
                            bulkUpdateOption.isBulkEmailUpdated = this.model.bulkUpdateSetting.isBulkEmailUpdated;
                            this.setBulkNotificationUpdateSetting(bulkUpdateOption.communicationType, bulkUpdateOption.bulkUpdateType, "isBulkEmailUpdated", bulkUpdateOption.isBulkEmailUpdated)
                        }
                        else if (this.model.bulkUpdateSetting.isBulkSMSUpdated) {
                            bulkUpdateOption.isBulkSMSUpdated = this.model.bulkUpdateSetting.isBulkSMSUpdated;
                            this.setBulkNotificationUpdateSetting(bulkUpdateOption.communicationType, bulkUpdateOption.bulkUpdateType, "isBulkSMSUpdated", bulkUpdateOption.isBulkSMSUpdated)
                        }
                        else if (this.model.bulkUpdateSetting.isBulkSendDaysUpdated) {
                            bulkUpdateOption.isBulkSendDaysUpdated = this.model.bulkUpdateSetting.isBulkSendDaysUpdated;
                            this.setBulkNotificationUpdateSetting(bulkUpdateOption.communicationType, bulkUpdateOption.bulkUpdateType, "isBulkSendDaysUpdated", bulkUpdateOption.isBulkSendDaysUpdated)
                        }
                    }
                }
            }
        }

        setBulkOptInUpdateSetting(bulkUpdateSettingName: string, bulkUpdateSettingValue: boolean): void {

            // Validate bulk update setting selection: only ONE bulk update setting is allowed to be enabled.
            if (this.model.isBulkUpdateSettingEnabled) {
                if (this.isBulkEmailOptInUpdated || this.isBulkSMSOptInUpdated) return;

                var bulkNotificationUpdateSettingSelected: any = _.first(this.bulkNotificationUpdateSettingList.filter(bnu => bnu.isBulkEmailUpdated || bnu.isBulkSMSUpdated || bnu.isBulkSendDaysUpdated));
                if (bulkNotificationUpdateSettingSelected) return;
            }

            // Initialize bulkUpdateSetting
            if (this.model.bulkUpdateSetting == undefined) {
                this.model.bulkUpdateSetting = {};
            }

            this.model.isBulkUpdateSettingEnabled = bulkUpdateSettingValue;

            if (bulkUpdateSettingName == "isBulkEmailOptInUpdated") {
                this.model.bulkUpdateSetting.isBulkEmailOptInUpdated = bulkUpdateSettingValue;
            }
            else if (bulkUpdateSettingName == "isBulkSMSOptInUpdated") {
                this.model.bulkUpdateSetting.isBulkSMSOptInUpdated = bulkUpdateSettingValue;
                this.model.bulkUpdateSetting.isBulkSendSMSOptInUpdated = bulkUpdateSettingValue;
                this.isBulkSendSMSOptInUpdated = bulkUpdateSettingValue;
            }
        }

        resetBulkOptInUpdateSetting(settingName: string, settingValue: boolean): void {

            if (!settingValue && this.model.bulkUpdateSetting && this.model.isBulkUpdateSettingEnabled) {

                if (settingName == 'isClientEmailOptInEnabledDefault' && this.isBulkEmailOptInUpdated) {
                    this.isBulkEmailOptInUpdated = false;
                    this.model.bulkUpdateSetting.isBulkEmailOptInUpdated = false;
                    this.model.isBulkUpdateSettingEnabled = false;
                }
                else if (settingName == 'isClientSMSOptInEnabledDefault' && this.isBulkSMSOptInUpdated) {
                    this.isBulkSMSOptInUpdated = false;
                    this.isBulkSendSMSOptInUpdated = false;
                    this.model.bulkUpdateSetting.isBulkSMSOptInUpdated = false;
                    this.model.bulkUpdateSetting.isBulkSendSMSOptInUpdated = false;
                    this.model.isBulkUpdateSettingEnabled = false;
                }
            }
        }

        setBulkNotificationUpdateSettingEllipsis(notification): any {

            if (this.showEllipsisContent) {
                if (this.selectedEllipsisType === undefined || this.selectedEllipsisType !== notification.communicationType) return;

                var bulkNotificationUpdateSettingSelected: any = _.first(this.bulkNotificationUpdateSettingList.filter(bnu => bnu.isBulkEmailUpdated || bnu.isBulkSMSUpdated || bnu.isBulkSendDaysUpdated));
                if (bulkNotificationUpdateSettingSelected && this.selectedEllipsisType !== notification.communicationType) return;
            }

            this.showEllipsisContent = !this.showEllipsisContent;
            this.selectedEllipsisType = notification.communicationType;
        }

        setBulkNotificationUpdateSetting(communicationType: CommunicationTypeEnum, bulkUpdateType: BulkClientNotificationUpdateEnum, bulkUpdateOptionName: string, bulkUpdateOptionValue: boolean): void {

            // Set selected communication type to bulkNotificationUpdateSettingsList
            for (var item of this.bulkNotificationUpdateSettingList) {
                item.communicationType = communicationType;
            }

            // Validate bulk update setting selection: only ONE bulk update setting is allowed to be enabled.
            var bulkNotificationUpdateSettingSelected: any = _.first(this.bulkNotificationUpdateSettingList.filter(bnu => bnu.isBulkEmailUpdated || bnu.isBulkSMSUpdated || bnu.isBulkSendDaysUpdated));
            if (this.model.isBulkUpdateSettingEnabled) {
                if (bulkNotificationUpdateSettingSelected && !bulkUpdateOptionValue) return;
                if (this.isBulkEmailOptInUpdated || this.isBulkSMSOptInUpdated) return;
            }

            // Initialize bulkUpdateSetting
            if (this.model.bulkUpdateSetting == undefined) {
                this.model.bulkUpdateSetting = {};
            }

            this.model.isBulkUpdateSettingEnabled = bulkUpdateOptionValue;

            // Assign selection to bulkUpdateSetting
            this.model.bulkUpdateSetting.communicationType = communicationType;
            this.model.bulkUpdateSetting.bulkUpdateType = bulkUpdateOptionValue ? bulkUpdateType : BulkClientNotificationUpdateEnum.ClearOut;
            if (bulkUpdateOptionName == "isBulkEmailUpdated")
                this.model.bulkUpdateSetting.isBulkEmailUpdated = bulkUpdateOptionValue;
            else if (bulkUpdateOptionName == "isBulkSMSUpdated")
                this.model.bulkUpdateSetting.isBulkSMSUpdated = bulkUpdateOptionValue;
            else if (bulkUpdateOptionName == "isBulkSendDaysUpdated")
                this.model.bulkUpdateSetting.isBulkSendDaysUpdated = bulkUpdateOptionValue;
        }

        setNotificationOptionsCollapse(notification): any {

            if (this.showCollapseContent) {
                if (this.selectedCollapseType === undefined || this.selectedCollapseType !== notification.communicationType) return;
            }

            this.showCollapseContent = !this.showCollapseContent;
            this.selectedCollapseType = notification.communicationType;
        }

    }
}